// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:34:09+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1c9859b510ac48f1c64e39dd54942eec
//    Signature:      eyJpdiI6Ijc2cFNEbXROY0xUTkRwOVwvSU5Ud2t3PT0iLCJ2YWx1ZSI6IkFcL2ZKTUpjK2lTVGRvcXhGMGlOZSttVytMT25vcWgwMHhRT251ek5QWUJsSWlaZGtRRWpldWVnYnJ0NmlNTFpnT3BqSWJQRVNUeVRBOFBDU05UN1NCSlprV3JIaXVXZmx1Uzg1MldyXC9qdnA2WnRkQ1Q2SVpGNzkyZzdTUXhtU29HRmdoVXp3aklyQmtEUmlcLzJ6ZWdoNXN4YXJXNWpDbmRWZjB3WlYxYSswTmNYRk5rQ1RRU2c1NDUzbVBROXBSbEFoNkxSU09EQnRySUVvUzh6Z3ZxN0poakx4V3ZPN2Vtc0o5YzZkdFlKR0QxVXhnamsrcEVseTh4Y2N0T0xqT2Z0ZkFJXC9PSWVwYzBnaVwvMkp0WnBkWk40bFNDd2NrYWtGa2xsTmNlTVwvRWtcL1h5QXAyY1lKWVwvcXRXaGJVU0taRFpOZUFUYjE3R2NyNVBpV0pWSzBSXC8rdHRCOHBxZDY5dlhnV09jMlNRMERxOTRVSk41VlhnbW1ZZlwvYVVvVld4bm9wMmcxNUQ4S0FYcEU5QkJYcjZJNTBBPT0iLCJtYWMiOiJiZGIxNDQ0MjU1NzQ2MWIzN2VkZjQ2NTgyZTg1YWJhNWRmMWJiYWM0YWQwYTBhNWU3MjNhMmE0NmQ3MGRmYzQ1In0=
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
